import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Link } from "react-router-dom";
import api, { formatDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Printer, ArrowLeft, Factory as FactoryIcon } from "lucide-react";

export default function HojaFabricacion() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders").then(({ data }) => {
      const filt = data.filter((o) =>
        ["creado", "fabricacion"].includes(o.estado) ||
        (o.estado === "empaque" && o.estado_fabricacion !== "listo")
      );
      setOrders(filt);
    });
  }, []);

  return (
    <div className="min-h-screen bg-white text-zinc-900" data-testid="hoja-fabricacion-page">
      <style>{`
        @media print {
          .no-print { display: none !important; }
          .lot-page { page-break-after: always; }
          .lot-page:last-child { page-break-after: auto; }
          body { background: white; }
        }
      `}</style>

      <div className="no-print border-b border-zinc-200 px-4 py-3 flex items-center justify-between sticky top-0 bg-white z-10">
        <Link to="/fabricacion" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-zinc-900">
          <ArrowLeft className="w-4 h-4" /> Volver a Fabricación
        </Link>
        <div className="text-sm text-zinc-500"><FactoryIcon className="w-4 h-4 inline mr-1" /> {orders.length} orden{orders.length === 1 ? "" : "es"} en cola</div>
        <Button onClick={() => window.print()} className="bg-[#002FA7] hover:bg-[#00227A] gap-2" data-testid="print-fab-btn">
          <Printer className="w-4 h-4" /> Imprimir todo
        </Button>
      </div>

      <div className="max-w-3xl mx-auto p-6 md:p-10">
        {orders.length === 0 && (
          <div className="text-center text-zinc-400 py-16">No hay órdenes pendientes de fabricación.</div>
        )}
        {orders.map((o) => (
          <div key={o.id} className="lot-page mb-8 border border-zinc-200 rounded-md p-8">
            <header className="flex items-start justify-between border-b-2 border-zinc-900 pb-3 mb-4">
              <div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-zinc-500 font-semibold">Hoja de fabricación</div>
                <div className="font-manrope font-black tracking-tight text-3xl mt-1">{o.numero}</div>
                <div className="text-xs text-zinc-500">Entrega prevista: {formatDate(o.fecha_entrega) || "sin fecha"}</div>
              </div>
              <QRCodeSVG value={o.numero} size={80} level="M" />
            </header>

            <div className="grid grid-cols-2 gap-4 text-sm mb-4">
              <div>
                <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold">Cliente</div>
                <div className="font-semibold">{o.cliente_nombre}</div>
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold">Envío</div>
                <div>{o.envio_nombre || "—"}</div>
              </div>
            </div>

            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="border-b border-zinc-900 text-left">
                  <th className="py-2 pr-2">Producto</th>
                  <th className="py-2 pr-2">Color</th>
                  <th className="py-2 pr-2">Tamaño</th>
                  <th className="py-2 pr-2">Estilo</th>
                  <th className="py-2 pr-2 text-right">Cant.</th>
                  <th className="py-2 pl-4 w-20 text-center">Check</th>
                </tr>
              </thead>
              <tbody>
                {o.items.map((it, i) => (
                  <tr key={i} className="border-b border-zinc-200">
                    <td className="py-2 pr-2 font-medium">{it.product_name}</td>
                    <td className="py-2 pr-2 text-zinc-600">{it.color || "—"}</td>
                    <td className="py-2 pr-2 text-zinc-600">{it.tamano || "—"}</td>
                    <td className="py-2 pr-2 text-zinc-600">{it.estilo || "—"}</td>
                    <td className="py-2 pr-2 text-right tabular-nums font-semibold">{it.cantidad}</td>
                    <td className="py-2 pl-4 text-center"><span className="inline-block w-5 h-5 border border-zinc-900 rounded"></span></td>
                  </tr>
                ))}
              </tbody>
            </table>

            {(o.notas || (o.notas_fab ?? o.notas_hoja)) && (
              <div className="mt-4 p-3 border border-zinc-300 rounded-md text-sm whitespace-pre-wrap">
                <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold mb-1">Notas</div>
                {[o.notas ? `Pedido: ${o.notas}` : "", (o.notas_fab ?? o.notas_hoja) || ""].filter(Boolean).join("\n")}
              </div>
            )}

            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="border-t border-zinc-900 pt-2 text-center text-xs text-zinc-600">Producido por</div>
              <div className="border-t border-zinc-900 pt-2 text-center text-xs text-zinc-600">Revisado por</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
